(ns net.kestec.mhda-pilgrimage.public.application.new-application-popup
  (:require ["@mui/material/Button" :default Button]
            ["@mui/material/Typography" :default Typography]
            ["@mui/material/Modal" :default Modal]
            ["@mui/material/Grid" :default Grid]
            ["@mui/material/TextField" :default TextField]
            ["@mui/icons-material/Cancel" :default CancelIcon]
            ["@mui/icons-material/Done" :default DoneIcon]
            [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-min-text-length]]
            [net.kestec.mhda-pilgrimage.db :as-alias db]
            [net.kestec.mhda-pilgrimage.public.applications.applications-events :as-alias applications-events]
            [ajax.core :as ajax]
            [net.kestec.re-frame.event :as-alias event]
            [re-frame.core :as rf]
            [reagent.core :as r]))




(def VALIDATOR
  {:shown_first_name {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen"}
   :shown_last_name  {:check-fn (check-min-text-length 3) :error-text "mindestens 3 Zeichen"}
   })

(defn- new-application-popup-form* [!form-data]
  (let [field-validator (form-field-validator VALIDATOR !form-data)
        form-valid (form-validator VALIDATOR !form-data)]
    [:div
     {:class "modal"
      :style {:max-height "70vh" :max-width "70vw" :min-height "200px" :min-width "300px"}}
     [:div
      ;[:pre "PRE "(pr-str claim)]
      [:> Grid {:container  true
                :direction  "row"
                :justify    "center"
                :alignItems "flex-start"
                :spacing    2}

       ;[:> Grid {:item true :xs 12} (pr-str claim)]
       [:> Grid {:item true :xs 12}

        [:br]
        [:> Typography "Bitte geben sie den " [:b "Rufname / Namenschild"] " der Person die sie anmelden wollen an:"]
        ]


       [:> Grid {:item true :xs 12 :md 6}
        [:> TextField {:label           "Rufname / Namenschild Vorname"
                       :fullWidth       true
                       :size            "small"
                       :value           (:shown_first_name @!form-data)
                       :error           (:error (field-validator :shown_first_name))
                       :helperText      (:helperText (field-validator :shown_first_name))
                       :onChange        #(swap! !form-data assoc :shown_first_name (.. % -target -value))
                       :InputLabelProps {:disableAnimation true :shrink true}}
         ]
        ]
       [:> Grid {:item true :xs 12 :md 6}
        [:> TextField {:label           "Rufname / Namenschild Nachname"
                       :fullWidth       true
                       :size            "small"
                       :value           (:shown_last_name @!form-data)
                       :error           (= "" (:shown_last_name @!form-data))
                       :helperText      (when (= "" (:shown_last_name @!form-data)) "mindestens 3 Zeichen")
                       :onChange        #(swap! !form-data assoc :shown_last_name (.. % -target -value))
                       :InputLabelProps {:disableAnimation true :shrink true}}
         ]
        ]
       ]]
     ;[:pre (pr-str (form-valid))]
     [:br]

     [:br]

     [:> Button
      {:sx        {:float "left"}
       :variant   "outlined"
       :startIcon (r/as-element [:> CancelIcon])
       :onClick   #(rf/dispatch [::applications-events/set-show-new-application-popup nil])
       }
      "Abbrechen"]

     [:> Button {:sx        {:float "right"}
                 :startIcon (r/as-element [:> DoneIcon])
                 :disabled  (not (:valid form-valid))
                 :variant   "contained"
                 :color     "primary"
                 :onClick   #(rf/dispatch [::applications-events/create-new-application @!form-data])
                 } "Anmeldung anlegen"]
     ]
    ))



(defn new-application-popup []
  (when-let [show-new-application-popup @(rf/subscribe [::db/get ::db/show-new-application-popup])]
    (let [!form-data (r/atom {:shown_first_name "" :shown_last_name ""})]
      [:> Modal {:aria-labelledby  "simple-modal-title"
                 :aria-describedby "simple-modal-description"
                 :style            {:display        "flex"
                                    :marginRight    "auto"
                                    :marginLeft     "auto"
                                    :alignItems     "center"
                                    :justifyContent "center"}
                 :open             (if (nil? show-new-application-popup) false true)

                 }
       [:f> new-application-popup-form* !form-data]])))